import React, { ReactElement, ReactNode } from 'react';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { OfflineErrorState } from './OfflineErrorState';
import { LoadingErrorState } from './LoadingErrorState';
import { observer } from 'mobx-react-lite';

export interface ErrorStateProps {
  dataHook?: string;
  errorStatus?: {
    error: unknown;
  } | null;
  renderError?: (params: {
    err: unknown;
    isOnline: boolean;
    retry: () => void;
  }) => ReactElement;
  state: {
    errorStatus?: {
      error: unknown;
    } | null;
    retryErrorState: () => void;
  };
  image?: ReactNode;
}

function _ErrorState({
  state,
  errorStatus: errorStatusProp,
  renderError,
  dataHook,
  image,
}: ErrorStateProps) {
  const {
    onlineState: { isOnline },
  } = useWixPatternsContainer();

  const errorStatus = errorStatusProp ?? state.errorStatus;

  if (!isOnline) {
    return (
      <OfflineErrorState
        image={image}
        onRetry={state.retryErrorState}
        dataHook={dataHook}
      />
    );
  }

  if (renderError && errorStatus) {
    return renderError({
      err: errorStatus.error,
      isOnline,
      retry: state.retryErrorState,
    });
  }

  return (
    <LoadingErrorState
      image={image}
      dataHook={dataHook}
      onRetry={state.retryErrorState}
    />
  );
}

export const ErrorState = observer(_ErrorState);
